// TODO make all accurance of card useing this component
// TODO add _card.css to this component
import Icon from 'components/utils/Icon';

export default function Card({
  title,
  icon,
  topLeftChildren,
  topRightChildren,
  children,
  list,
}) {
  return (
    <div className={`card ${list ? 'list' : 'grid'}`}>
      <div
        className={`info-row${
          !title && topRightChildren && !topLeftChildren
            ? ' info-row-flex-end'
            : ''
        }`}
      >
        {!!topLeftChildren && <div>{topLeftChildren}</div>}
        {title ? (
          <div className="title">
            {icon && <Icon type={icon} />}
            {title}
          </div>
        ) : (
          ''
        )}
        {!!topRightChildren && <div>{topRightChildren}</div>}
      </div>
      <div className="body">{children}</div>

      <style jsx>{`
        :root {
        }
        @media screen and (min-width: 768px) {
          :root {
            --card-padding: 1rem;
          }
        }
        .card.list {
        }
        .list {
          display: flex;
          flex-direction: row;
        }
        .list .body {
          display: flex;
          width: 100%;
          align-items: center;
        }
        .card {
          position: relative;
          background: var(--background-utils);
          border-radius: var(--radius-lg);
          border: 1px solid var(--card-border);
          padding: var(--card-padding);
          overflow: auto;
          margin: 0 calc(-1 * var(--margin-sm)) var(--margin-md)
            calc(-1 * var(--margin-sm));
        }
        .title {
          font-size: 15px;
          font-weight: 700;
          line-height: 25px;
          margin-bottom: 1em;
        }
        .title :global(.icon) {
          margin-right: 10px;
        }
        @media only screen and (min-width: 768px) {
          .card {
            overflow: unset;
            padding: var(--margin-md);
            margin: 0 0 var(--margin-md) 0;
            border: solid thin var(--card-border);
          }
        }
        .list .info-row {
          margin: 0 8px;
        }
        .info-row {
          display: flex;
          justify-content: space-between;
        }
        .info-row-flex-end {
          justify-content: flex-end;
        }
      `}</style>
    </div>
  );
}
